import { useTranslation } from 'react-i18next';

import {
  renderAssetNameWithAncestors,
  renderAssetSite,
} from 'components/data/assets/assetColumnRenderers';
import { getAssetByType } from 'horizon/components/Assets/AssetDetails/helpers';
import { Description, Label } from 'horizon/components/Damages/DamageStyles.style';
import { type AtlasGqlAsset } from 'types/atlas-graphql';
import { getAssetFieldValueString } from 'utils/asset-helpers';

type AssetProps = {
  asset: AtlasGqlAsset;
};

export const Asset: React.FunctionComponent<AssetProps> = ({ asset }) => {
  const { t } = useTranslation();
  const assetType = asset.assetType?.name;
  const assetMake = getAssetFieldValueString(asset, 'Make');
  const assetModel = getAssetFieldValueString(asset, 'Model');
  const turbine = getAssetByType(asset as AtlasGqlAsset, 'Turbine');
  const turbineMake = turbine && getAssetFieldValueString(turbine, 'Make');
  const turbineModel = turbine && getAssetFieldValueString(turbine, 'Model');

  return (
    <div>
      <div>
        <Label>{t('table.site', 'Site')}</Label>
        <Description>{renderAssetSite(asset)}</Description>
      </div>
      <div>
        <Label>{t('table.asset', 'Asset')}</Label>
        <Description>{renderAssetNameWithAncestors(asset, 'damages2')}</Description>
      </div>
      <div>
        <Label>{t('table.assetType', 'Asset Type')}</Label>
        {assetType && <Description>{assetType}</Description>}
      </div>
      {assetType !== 'Turbine' && (
        <>
          {turbineMake && (
            <div>
              <Label>{t('assets.turbineMake', 'Turbine Make')}</Label>
              <Description>{turbineMake}</Description>
            </div>
          )}
          {turbineModel && (
            <div>
              <Label>{t('assets.turbineModel', 'Turbine Model')}</Label>
              <Description>{turbineModel}</Description>
            </div>
          )}
        </>
      )}
      <div>
        <Label>
          {assetType
            ? t('assets.assetTypeMake', '{{assetType}} Make', { assetType })
            : t('table.make', 'Make')}
        </Label>
        {assetMake && <Description>{assetMake}</Description>}
      </div>
      <div>
        <Label>
          {assetType
            ? t('assets.assetTypeModel', '{{assetType}} Model', { assetType })
            : t('table.model', 'Model')}
        </Label>
        {assetModel && <Description>{assetModel}</Description>}
      </div>
    </div>
  );
};
